/**
 * @namespace IPService
 */

/**
 * Converts an IPv4 address to a 32-bit number.
 * @param {string} ip - The IPv4 address (e.g., "192.168.1.1").
 * @returns {number} The numeric representation of the IP.
 */
function ipToLong(ip) {
    return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0;
}

/**
 * Checks if an IP address is within a given CIDR range.
 * @param {string} ip - The IPv4 address to check.
 * @param {string} cidr - The CIDR range (e.g., "192.168.1.0/24").
 * @returns {boolean} True if the IP is in the CIDR range, false otherwise.
 */
function isIpInCidr(ip, cidr) {
    const [range, bits = "32"] = cidr.split('/');
    const mask = ~(2 ** (32 - Number(bits)) - 1) >>> 0;
    const ipLong = ipToLong(ip);
    const rangeLong = ipToLong(range);

    return (ipLong & mask) === (rangeLong & mask);
}

const IPService = {
    ipToLong,

    isIpInCidr,

    /**
     * Checks if the provided IP matches any IP or CIDR mask in the list.
     * @param {string} ip - The IPv4 address to check.
     * @param {string[]} list - Array of IPs or CIDR masks.
     * @returns {boolean} True if the IP matches any entry in the list, false otherwise.
     */
    ipMatchesList(ip, list) {
        if (!ip || !Array.isArray(list) || list.length === 0) {
            return false;
        }
        return list.some(entry => {
            if (typeof entry !== 'string') return false;
            if (entry.includes('/')) {
                // CIDR mask
                try {
                    return isIpInCidr(ip, entry);
                } catch {
                    return false;
                }
            } else {
                // Single IP
                return ip === entry;
            }
        });
    }
};

export default IPService;